import { ForgotPasswordScreen } from '@platform/app-kit';
import { AUTH_FRAME } from '../shell/brand.ts';

export function ForgotPasswordPage() {
  return <ForgotPasswordScreen frame={AUTH_FRAME} signInHref="/login" />;
}
